import React, { useState } from "react";
import "./BestBusiness.css";
const BestBusiness = () => {
  const [activeBox, setActiveBox] = useState("boxB-i");

  const boxes = [
    {
      id: "boxB-i",
      icon: "./assets/images/icons/email-marketing.svg",
      title: "Email Marketing",
      image: "./assets/images/box-image/email.svg",
      description: "Achieve your marketing goals with scalable, personalized email automation."
    },
    {
      id: "boxB-ii",
      icon: "./assets/images/icons/advertising.svg",
      title: "Social Marketing",
      image: "./assets/images/box-image/social.svg",
      description: "Product is what you are marketing everyday, personalized email automation."
    },
    {
      id: "boxB-iii",
      icon: "./assets/images/icons/video.svg",
      title: "Video Marketing",
      image: "./assets/images/box-image/video.svg",
      description: "Highly Customizable Campaign Report Data, personalized email automation."
    },
    {
      id: "boxB-iv",
      icon: "./assets/images/icons/badge.svg",
      title: "Market Analysis",
      image: "./assets/images/box-image/analysis.svg",
      description: "Get Actionable Insights. Purpose Built Trading Platform, personalized email automation."
    }
  ];

  return (
    <div className="se-ix pt-4">
      <div className="container">
        {/* Head */}
        <div className="section-head">
          <h2>ONLY THE BEST FOR YOUR BUSINESS!</h2>
          <div className="lines">
            <span></span>
          </div>
          <p>
            Our goal is to build lasting relationships with the people we work with, and to deliver outstanding results to bridge the gap between where they are now and where they want to be.
          </p>
        </div>

        {/* Content */}
        <div className="content">
          {/* Boxes Nav */}
          <ul className="boxes-nav list-unstyled d-flex align-items-center justify-content-lg-center">
            {boxes.map((boxB) => (
              <li
                key={boxB.id}
                className={`d-flex align-items-center justify-content-center ${activeBox === boxB.id ? "active" : ""}`}
                onClick={() => setActiveBox(boxB.id)}
              >
                <img src={boxB.icon} className="img-fluid" alt={boxB.title} />
                <span className="name d-inline-block text-capitalize">{boxB.title}</span>
              </li>
            ))}
          </ul>

          {/* Boxes */}
          <div className="boxes">
            {boxes.map((boxB) => (
              <div key={boxB.id} className="boxB" style={{ display: activeBox === boxB.id ? "block" : "none" }}> 
                <div className="row align-items-start box-container">
                  <div className="col-4 d-lg-block d-none text-center box1">
                    <img src={boxB.image} className="img-fluid" alt={boxB.title} />
                  </div>
                  <div className="col-8 col-lg-6 box2">
                    <div className="text">
                      <h4 className="mb-2 mt-5"><b>{boxB.description.split(",")[0]}</b>{boxB.description.split(",")[1]}</h4>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BestBusiness;
